module.exports = __webpack_public_path__ + "img/38.ec961321.jpg";